<template>
    <div class="table">
        <div class="container" style="width:95%;">
            <el-form ref="form" :model="form" v-loading="loading" :rules="rules" label-width="230px">
                <el-form-item prop="deptId" label="学校：">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="onDeptChange" style="width:230px;">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-divider content-position="left">班级报告信息配置</el-divider>
                <el-form-item prop="moduleSwitch" label="启用报告："><el-checkbox v-model="form.moduleSwitch"></el-checkbox></el-form-item>
                <el-form-item label="考评日期范围：">
                   每学年的上学期是
                   <el-date-picker style="width:140px;"
                        :disabled="!form.moduleSwitch"
                        v-model="form.lastStartDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>到明年
                    <el-date-picker style="width:140px;"
                        :disabled="!form.moduleSwitch"
                        v-model="form.lastEndDate"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">>
                    </el-date-picker>
                    ，
                    下学期是明年的
                    <el-date-picker style="width:140px;"
                        v-model="form.nextStartDate"
                        :disabled="!form.moduleSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">
                    </el-date-picker>
                    到
                    <el-date-picker style="width:140px;"
                        v-model="form.nextEndDate"
                        :disabled="!form.moduleSwitch"
                        :readonly="setReadonly"
                        type="date"
                        placeholder="选择日期"
                        format="MM-dd"
                        value-format="MM-dd">>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="推送人员名单（小学部）：">
                    <el-button @click="queryPrimaryUser()" :disabled="!form.moduleSwitch">{{form.userPrimaryLabel}}</el-button>
                </el-form-item>
                <el-form-item label="推送人员名单（初中部）：">
                    <el-button @click="queryMiddleUser()" :disabled="!form.moduleSwitch">{{form.userMiddleLabel}}</el-button>
                </el-form-item>
                <el-form-item prop="calculateTime" label="生成和推送时间：">
                    每周
                    <el-select v-model="form.executeDay" placeholder="请选择" :disabled="!form.moduleSwitch" style="width: 100px;">
                        <el-option
                            v-for="item in days"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>&nbsp;
                    <el-time-select style="width:140px;"
                        v-model="form.calculateTime"
                        :disabled="!form.moduleSwitch"
                        :readonly="setReadonly"
                        :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '23:59'
                        }"
                        placeholder="选择时间">
                    </el-time-select><span style="color:red;font-size:13px;"></span>
                </el-form-item>
                <el-form-item label="提示词模板：" v-if="isAdmin">
                    <el-input
                        type="textarea"
                        :rows="6"
                        :disabled="!form.moduleSwitch"
                        v-model="form.promptTemplate"
                        :maxlength="3000"
                        show-word-limit
                        placeholder="请输入提示词模板"
                        style="width: 500px;">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="danger" @click="clearConfig()">清空配置</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
        </div>
        <!-- 人员弹出框 -->
        <div v-if="selectUsersVisible">
            <selectUsers ref="selectUsers"></selectUsers>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import selectUsers from '../../sys/user/UserTransfer.vue';
    import { MessageBox } from 'element-ui';

    export default {
        data(){
            return{
                loading: false,
                setReadonly: false,
                selectUsersVisible: false,

                form:{
                    moduleSwitch: false,
                    deptId: "", // 学校ID

                    lastStartDate: "", // 上学期开始日期
                    lastEndDate: "", // 上学期结束日期
                    nextStartDate: "", // 下学期开始日期
                    nextEndDate: "", // 下学期结束日期
                    executeDay: "", // 几号执行
                    calculateTime: "", // 推送与生成日期
                    promptTemplate: "", // 提示词模板

                    userPrimaryIds: [],  // 小学用户ID，多个用逗号隔开
                    userPrimaryLabel: "请选择",
                    userMiddleIds: [],  // 初中用户ID，多个用逗号隔开
                    userMiddleLabel: "请选择",
                },
                userType: 0,
                depts: [],
                days: [],
                isAdmin: false,
                rules: {
                    deptId: [
                        { required: true, message: '请选择学校', trigger: 'blur' }
                    ],
                    executeDay: [
                        { required: true, message: '请选择每周几执行', trigger: 'blur' }
                    ],
                    calculateTime: [
                        { required: true, message: '请选择生成和推送时间', trigger: 'blur' }
                    ]
                }
            }
        },
        created: function () {
            this.getDeptData()
            // 初始星期一~星期日
            let weekNames = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
            for(let i = 0; i < weekNames.length; i++){
                this.days.push({ value: i + 1, label: weekNames[i] })
            }

            // 判断当前用户是否是超级管理员
            const userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}');
            this.isAdmin = userinfo && userinfo.id == 1;
        },
        components: {
            selectUsers
        },
        methods:{
            // 获取部门管理
            getDeptData(){
                let url = this.listDeptUrl;
                let data = {parentId: "0"};
                this.apiPost(url, data).then((res) => {
                    if(res.status == 200){
                        this.depts = res.data.list;
                        if(this.depts.length > 0){
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => {
                    console.log(err);
                });
            },
            // 切换学校
            onDeptChange(){
                this.getData();
            },
            // 根据条件获取当前界面数据
            getData(){
                this.clear(); // 清空数据
                this.form.moduleSwitch = false
                let url = this.classReportConfigListUrl;
                let data = {
                    deptId: this.form.deptId
                };
                this.apiPost(url, data).then((res) => {
                    if(res.status == 200){
                        let resultData = res.data
                        console.log('resultData', resultData)
                        for(let i = 0; i < resultData.length; i++){
                            let obj = resultData[i]

                            if(obj.setKey == 'switch_key'){ // 开关
                                if(obj.setVal == 1){
                                    this.form.moduleSwitch = true
                                }else{
                                    this.form.moduleSwitch = false
                                }
                            } if(obj.setKey == 'dateRange_key'){ // 考评日期范围
                                let dateRange = JSON.parse(obj.setVal)
                                this.form.lastStartDate = dateRange.lastStartDate
                                this.form.lastEndDate = dateRange.lastEndDate
                                this.form.nextStartDate = dateRange.nextStartDate
                                this.form.nextEndDate = dateRange.nextEndDate
                            }else if(obj.setKey == 'push_primary_teacher_set_key'){
                                if(this.$util.isNotEmpty(obj.setVal)){
                                    this.form.userPrimaryIds = obj.setVal.split(',')
                                    this.form.userPrimaryLabel = this.form.userPrimaryIds.length + "人"
                                }else{
                                    this.form.userPrimaryIds = []
                                    this.form.userPrimaryLabel = "请选择"
                                }
                            }else if(obj.setKey == 'push_middle_teacher_set_key'){
                                if(this.$util.isNotEmpty(obj.setVal)){
                                    this.form.userMiddleIds = obj.setVal.split(',')
                                    this.form.userMiddleLabel = this.form.userMiddleIds.length + "人"
                                }else{
                                    this.form.userMiddleIds = []
                                    this.form.userMiddleLabel = "请选择"
                                }
                            }else if(obj.setKey == 'calculate_time_key'){ // 生成与推送时间
                                this.form.calculateTime = obj.setVal
                            }else if(obj.setKey == 'execute_day_key'){ // 每周几日执行
                                this.form.executeDay = obj.setVal
                            }else if(obj.setKey == 'prompt_template_key'){ // 提示词模板
                                this.form.promptTemplate = obj.setVal
                            }
                        }
                    }else{
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => {
                    console.log(err);
                    this.$commonFn.showTip(err, 3);
                });
            },
            // 小学绑定人员
            queryPrimaryUser(){
                this.selectUsersVisible = true
                this.userType = 0
                this.$nextTick(() => {
                    console.log('选中', this.form.userPrimaryIds)
                    this.$refs['selectUsers'].init(2, this.form.userPrimaryIds, 2, this.form.deptId);
                })
            },
            // 初中绑定人员
            queryMiddleUser(){
                this.selectUsersVisible = true
                this.userType = 1
                this.$nextTick(() => {
                    console.log('选中', this.form.userMiddleIds)
                    this.$refs['selectUsers'].init(2, this.form.userMiddleIds, 2, this.form.deptId);
                })
            },
            setUser(keyArr){
                if(this.userType == 0){
                    if(keyArr.length == 0){
                        this.form.userPrimaryIds = keyArr;
                        this.form.userPrimaryLabel = "请选择";
                    }else{
                        this.form.userPrimaryIds = keyArr;
                        this.form.userPrimaryLabel = keyArr.length + "人";
                    }
                }else if(this.userType == 1){
                    if(keyArr.length == 0){
                        this.form.userMiddleIds = keyArr;
                        this.form.userMiddleLabel = "请选择";
                    }else{
                        this.form.userMiddleIds = keyArr;
                        this.form.userMiddleLabel = keyArr.length + "人";
                    }
                }
            },
            // 清空数据
            clear(){
                this.form.moduleSwitch = false
                this.form.lastStartDate = ""
                this.form.lastEndDate = ""
                this.form.nextStartDate = ""
                this.form.nextEndDate = ""
                this.form.executeDay = ""
                this.form.calculateTime = ""
                this.form.promptTemplate = ""
                this.form.userPrimaryIds = []
                this.form.userPrimaryLabel = "请选择"
                this.form.userMiddleIds = []
                this.form.userMiddleLabel = "请选择"
            },
            // 保存
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // 考评日期范围不为空验证
                        if(this.$util.isEmpty(this.form.lastStartDate)){
                            this.$commonFn.showTip('上学期开始日期不为空', 3)
                            return
                        }else if(this.$util.isEmpty(this.form.lastEndDate)){
                            this.$commonFn.showTip('上学期结束日期不为空', 3)
                            return
                        }else if(this.$util.isEmpty(this.form.nextStartDate)){
                            this.$commonFn.showTip('下学期开始日期不为空', 3)
                            return
                        }else if(this.$util.isEmpty(this.form.nextEndDate)){
                            this.$commonFn.showTip('下学期结束日期不为空', 3)
                            return
                        }

                        // 推送人员名单不可为空
                        if(this.form.userPrimaryIds.length == 0){
                            this.$commonFn.showTip('推送人员名单(小学部)不可为空', 3)
                            return
                        }

                        let obj = {};
                        // 启用班级报告
                        obj['switch_key'] = this.form.moduleSwitch ? 1 : 0
                        // 考评日期范围
                        let dateRange = {}
                        dateRange.lastStartDate = this.form.lastStartDate
                        dateRange.lastEndDate = this.form.lastEndDate
                        dateRange.nextStartDate = this.form.nextStartDate
                        dateRange.nextEndDate = this.form.nextEndDate
                        obj['dateRange_key'] = JSON.stringify(dateRange)
                        // push_primary_teacher_set_key
                        obj['push_primary_teacher_set_key'] = this.form.userPrimaryIds.join(',')
                        // push_middle_teacher_set_key
                        obj['push_middle_teacher_set_key'] = this.form.userMiddleIds.join(',')
                        // calculate_time_key
                        obj['calculate_time_key'] = this.form.calculateTime
                        obj['execute_day_key'] = this.form.executeDay
                        if (this.isAdmin) {
                            obj['prompt_template_key'] = this.form.promptTemplate
                        }
                        console.log(JSON.stringify(obj))

                        this.loading = true; // 正在保存中
                        let data = {
                            'deptId': this.form.deptId,
                            'data': JSON.stringify(obj)
                        };
                        this.apiPost(this.classReportConfigSaveUrl, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message, 1)
                            }else{
                                this.$commonFn.showTip(res.message, 3)
                            }
                            this.loading = false;
                        }, (err) => {
                            this.$commonFn.showTip(err, 3)
                            this.loading = false;
                        });
                    }
                });
            },
            // 清空配置
            clearConfig(){
                MessageBox.confirm('此操作将永久清空配置数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((resolve) => {
                    let url = this.classReportConfigDelUrl;
                    let data = {
                        deptId: this.form.deptId
                    };
                    this.apiPost(url, data).then((res) => {
                        if(res.status === 200){
                            this.$commonFn.showTip(res.message, 1);
                            this.getData();
                        }else{
                            this.$commonFn.showTip(res.message, 3);
                        }
                    }, (err) => {
                        this.$commonFn.showTip(err, 3);
                    });
                }).catch(() => {
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/classConfig/list.vue